import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "../../../../../languages/index.js";
import { SearchIcon } from "@heroicons/react/solid";
import {
  fetchdeliveredSellerOder,
  searchDeliveredsellerorders,
} from "../../../actions/index";
import Sellerdeliveroderitems from "./deliveroder-item";
import _ from "lodash";
import Pagination from "react-js-pagination";
import BaseLoader from "../../../../../../common/base-loader";

class Deliveredselleroder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      search: "",
      pageNumber: 1,
      loaderDesc: "Preparing Seller Orders",
    };

    // All Binded Functions
  }
  componentDidMount(data) {
    this.props.fetchdeliveredSellerOder(
      this.props.session,
      this.props.data.userid,
      this.state.pageNumber,
      (CallBackResponse) => {
        this.setState({ loading: false });
      }
    );
  }

  paginationCallback = (pageNumber) => {
    // alert(pageNumber)
    this.props.fetchdeliveredSellerOder(
      this.props.session,
      this.props.data.userid,
      pageNumber,
      (CallBackResponse) => {}
    );

    this.setState({ ...this.state, pageNumber });
  };
  handleSearch = (event) => {
    var search = event.target.value;
    var pageNumber = 1;

    if (search == "") {
      this.props.fetchdeliveredSellerOder(
        this.props.session,
        this.props.data.userid,
        pageNumber,
        (CallBackResponse) => {}
      );
    } else {
      this.props.searchDeliveredsellerorders(
        this.props.session,
        this.props.data.userid,
        search
      );
    }
    this.setState({ search, pageNumber });
  };
  renderList() {
    let pageDataLength = this.props.sellerdeliveredoderlist.count;

    let { pageNumber } = this.state;

    var items = _.map(
      this.props.sellerdeliveredoderlist.data,
      (values, index) => (
        <Sellerdeliveroderitems
          key={index}
          values={values}
          pagination={this.paginationCallback}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
        />
      )
    );
    // console.log('check', this.state.pageNumber);
    return items;
  }

  render() {
    return (
      <>
        {this.state.loading ? (
          <>
            <BaseLoader data={this.state.loaderDesc} />
          </>
        ) : (
          <>
            <div className="relative  text-ternary focus-within:text-secondary ">
              <div className="absolute inset-y-0 left-0 flex items-center pointer-events-none px-1">
                <SearchIcon className="h-5 w-5" aria-hidden="true" />
              </div>
              <input
                id="search-field"
                className="block lg:w-3/12 sm:w-full h-full pl-8 pr-3 py-2 border-transparent text-secondary placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm rounded-md"
                placeholder={LocaleStrings.search}
                type="search"
                name="search"
                value={this.state.search}
                onChange={this.handleSearch}
              />
            </div>
            {_.isEmpty(this.props.sellerdeliveredoderlist.data) ? (
              <>
                <div className="center-item lg:mt-48 text-lg text-ternary">
                  {LocaleStrings.nodeliverdeorders}
                </div>
              </>
            ) : (
              <>
                <div className="flex flex-col mt-5">
                  <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                      <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-custWhite">
                            <tr>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.oderid}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.odertotal}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.odererby}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.oderon}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.status}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.items}
                              </th>
                            </tr>
                          </thead>
                          <tbody>{this.renderList()}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <Pagination
                    activePage={this.state.pageNumber}
                    itemsCountPerPage={7}
                    totalItemsCount={this.props.sellerdeliveredoderlist.count}
                    pageRangeDisplayed={10}
                    onChange={this.paginationCallback}
                  />
                </div>
              </>
            )}
          </>
        )}
      </>
    );
  }
}

// var mapStateToProps = (state) => ({
//     isLoggedIn: state.isLoggedIn,
//     user: state.user,
//     session: state.session,
//   });

function mapStateToProps(state, ownProps) {
  var { isLoggedIn, user, session, sellerdeliveredoderlist } = state;
  // console.log('product',state.sellerdeliveredoderlist)
  return {
    isLoggedIn,
    session,
    user,
    sellerdeliveredoderlist,
    data: ownProps.data,
  };
}

export default connect(mapStateToProps, {
  fetchdeliveredSellerOder,
  searchDeliveredsellerorders,
})(Deliveredselleroder);
